let timer;

export default {
  login(context, payload) {
    return context.dispatch("auth", {
      ...payload,
      mode: "login",
    });
  },
  signup(context, payload) {
    return context.dispatch("auth", {
      ...payload,
      mode: "signup",
    });
  },
  async auth(context, payload) {
    console.group("auth");
    const mode = payload.mode;
    let url =
      "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDUi3Cdgi1Ka7avhCHKyD54wYIpS7q2u-4";

    if (mode === "signup") {
      url =
        "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyDUi3Cdgi1Ka7avhCHKyD54wYIpS7q2u-4";
    }

    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        email: payload.email,
        password: payload.password,
        returnSecureToken: true,
      }),
    });

    const responseData = await response.json();

    if (!response.ok) {
      console.log(responseData);
      const error = new Error(
        responseData.message || "Failed to authenticate. Check your login data."
      );
      throw error;
    }

    const expiresIn = +responseData.expiresIn * 1000;
    const expirationDate = new Date().getTime() + expiresIn;
    console.info("User Login expires in " + responseData.expiresIn + " seconds or " + responseData.expiresIn / 60 + " minutes.");
    console.info("User Login responseData", responseData);

    localStorage.setItem("token", responseData.idToken);
    localStorage.setItem("userId", responseData.localId);
    localStorage.setItem("tokenExpiration", expirationDate);
    localStorage.setItem("refreshToken", responseData.refreshToken);

    timer = setTimeout(function () {
      context.dispatch("autoLogout");
    }, expiresIn);

    context.commit("setUser", {
      token: responseData.idToken,
      userId: responseData.localId,
    });

    // now that we're logged in, we can load restricted data
    await context.dispatch("loadRestrictedData");

    if (mode === "signup") {
      context.dispatch("createUserProfile", {
        userId: responseData.localId,
        email: responseData.email,
      });
    } else {
      await context.dispatch("setCurrentUser", responseData.localId, { root: true });  
    }

    console.groupEnd();
  },
  async tryLogin(context) {
    console.group("tryLogin");

    var refreshToken = localStorage.getItem("refreshToken");
   
    if ( refreshToken ) {
      // we have a refresh Token, try refreshing it

      const response = await fetch("https://securetoken.googleapis.com/v1/token?key=AIzaSyDUi3Cdgi1Ka7avhCHKyD54wYIpS7q2u-4", {
        method: "POST",
        body: JSON.stringify({
          grant_type: "refresh_token",
          refresh_token: refreshToken,
        }),
      });
  
      const responseData = await response.json();
  
      if (response.ok) {
        console.info("Refreshing token successful, responseData = ", responseData);
        refreshToken = responseData.refresh_token;
        const expiresIn = +responseData.expires_in * 1000;
        const expirationDate = new Date().getTime() + expiresIn;
        localStorage.setItem("token", responseData.id_token);
        localStorage.setItem("userId", responseData.user_id);
        localStorage.setItem("tokenExpiration", expirationDate);
        localStorage.setItem("refreshToken", refreshToken);
      } else {
        console.info("Refreshing token failed, response = ", response);
      }
    }

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const tokenExpiration = localStorage.getItem("tokenExpiration");
    const expiresIn = +tokenExpiration - new Date().getTime();

    if (expiresIn < 0) {
      console.info("expiresIn < 0");
      console.groupEnd();
      return;
    }

    console.info("autoLogout in ", expiresIn / 1000, " seconds");
    timer = setTimeout(function () {
      context.dispatch("autoLogout");
    }, expiresIn);

    if (token && userId) {
      console.info("setting user: ", userId);

      context.commit("setUser", {
        token: token,
        userId: userId,
      });

      // await context.dispatch("setCurrentUser", userId, { root: true });  
    }

    console.groupEnd();
  },
  logout(context) {
    console.group("logout");
    console.info("logging out")
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("tokenExpiration");

    clearTimeout(timer);

    context.commit("setUser", {
      token: null,
      userId: null,
    });

    context.dispatch("clearCurrentUser", null, { root: true });
    console.groupEnd();
  },
  async autoLogout(context) {
    console.group("autoLogout");

    const refreshToken = localStorage.getItem("refreshToken");
    if ( refreshToken ) {
      // we have a refresh Token, try refreshing it

      const response = await fetch("https://securetoken.googleapis.com/v1/token?key=AIzaSyDUi3Cdgi1Ka7avhCHKyD54wYIpS7q2u-4", {
        method: "POST",
        body: JSON.stringify({
          grant_type: "refresh_token",
          refresh_token: refreshToken,
        }),
      });
  
      const responseData = await response.json();
  
      if (response.ok) {
        console.info("Refreshing token successful, responseData = ", responseData);
        const expiresIn = +responseData.expires_in * 1000;
        const expirationDate = new Date().getTime() + expiresIn;
        localStorage.setItem("token", responseData.id_token);
        localStorage.setItem("userId", responseData.user_id);
        localStorage.setItem("tokenExpiration", expirationDate);
        localStorage.setItem("refreshToken", responseData.refresh_token);

        console.info("autoLogout in ", expiresIn / 1000, " seconds");
        clearTimeout(timer);
        timer = setTimeout(function () {
          context.dispatch("autoLogout");
        }, expiresIn);
      } else {
        console.info("Refreshing token failed, response = ", response);
        context.dispatch("logout");
        context.commit("setAutoLogout");
      }
    }
    console.groupEnd();
  },
  async changeUserEmail(context, newEmail) {
    console.log("changeUserEmail(): newEmail = ", newEmail);

    const response = await fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyDUi3Cdgi1Ka7avhCHKyD54wYIpS7q2u-4",
      {
        method: "POST",
        body: JSON.stringify({
          idToken: context.rootGetters.token,
          email: newEmail,
          returnSecureToken: false,
        }),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      console.log(responseData);
      const error = new Error(
        responseData.message || "Failed to change email. Check your login data."
      );
      throw error;
    }

    console.log("changeUserEmail(): success!");
  },
  async resetPassword(context, emailAddress) {
    console.log("resetPassword(): Email = ", emailAddress);

    const response = await fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=AIzaSyDUi3Cdgi1Ka7avhCHKyD54wYIpS7q2u-4",
      {
        method: "POST",
        body: JSON.stringify({
          requestType: "PASSWORD_RESET",
          email: emailAddress,
        }),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      console.log(responseData);
      const error = new Error(
        responseData.message || "Failed to reset password. Email not on file."
      );
      throw error;
    }

    console.log("resetPassword(): success!");
  },
};
